// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Xlb9sckP-3kATIyE-qGYz","state":"IDopk3zbTy4QBjUhdzub7","sign":"_3Myecl8R37Bs1daZG4e-ve","signButton":"_2yp-pLy_3VGqGmRtu5biBn","checkboxAdjuntos":"_2y0I6WPkKYu06NOGJh9HHJ","feaState":"_28ZW6cdYk-Ks2CSU1XDU6v","btnCancelar":"RpsTLp41lVqEpvMLck05j","btnHeader":"_2tmnFCwTEQU6e--P3zVD42"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/Status/Title/Buttons/styles.css
// module id = 2843
// module chunks = 0